import { render, staticRenderFns } from "./screenshotMobile.vue?vue&type=template&id=e506e174&"
import script from "./screenshotMobile.vue?vue&type=script&lang=js&"
export * from "./screenshotMobile.vue?vue&type=script&lang=js&"
import style0 from "./screenshotMobile.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports